import React from 'react';
import styles from './NotFound.module.css';

import Button from '../button/Button';
import stylesButton from '../button/Button.module.css';

const NotFound = props => {
  return (
    <div className={styles.notfound_container}>
      <h1>404</h1>
      <h4>OOOPS!</h4>
      <span>Desculpe, mas esta página não existe.</span>
      <Button className={styles.error_button} styleType={stylesButton.reverse} onClick={() => props.history.replace('/home')}>Ir para home</Button>
    </div>
  );
};

export default NotFound;
